export const CHK_TOAST_VARIANT = {
  INFO: 'INFO',
  ERROR: 'ERROR',
} as const;
